export const createBoosterSourceSlice = (set) => ({
  boosterSource: null, // "stage3" | "stage4" | null
  setBoosterSource: (source) => set({ boosterSource: source }),
  clearBoosterSource: () => set({ boosterSource: null }),
});
